<template>
  <rabbey-base-drawer
    :title="
      data.requestsId
        ? 'Detalle de Solicitud #' + data.requestsId
        : 'Detalle de Solicitud'
    "
    size="60%"
    :drawer="drawer"
    v-on:update:drawer="$emit('update:drawer', $event)"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
    v-bind="$attrs"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <el-row v-if="data.Reopen">
      <el-col>
        <label style="font-weight: bold; margin-bottom: 105px">
          Esta solicitud fue REABIERTA por la siguiente razón:
        </label>
        <el-input
          type="textarea"
          :rows="3"
          disabled
          v-model="data.commentReasonToReopen"
        >
        </el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <label style="font-weight: bold; margin-bottom: 105px">
          Descripción Corta</label
        >
        <el-input
          type="textarea"
          :rows="3"
          disabled
          placeholder="Descripción Aquí"
          v-model="data.descripcionCorta"
        >
        </el-input>
      </el-col>
    </el-row>

    <el-row style="margin-bottom: 105px">
      <el-col>
        <label style="font-weight: bold; margin-bottom: 105px">
          Más Detalles</label
        >
        <quill-editor
          style="height: 275px"
          disabled
          ref="myQuillEditor"
          v-model="data.descripcionLaga"
        />
      </el-col>
    </el-row>

    <!-- v-if="FilesUploaded.UploadedFiles" -->

    <el-row v-if="FilesUploaded.length > 0">
      <el-col>
        <label class="labelArc" style="font-weight: bold; margin-bottom: 50px">
          Archivos de la Solicitud
        </label>
        <!-- <label> {{evidencesList.Evidences}}</label> -->

        <a
          v-for="(action, index) in FilesUploaded"
          :key="index"
          class="filesL"
          target="_blank"
          :href="action.UploadedFiles"
        >
          <img src="../.././../public/folder.png" class="filesL" />
        </a>
      </el-col>
    </el-row>
    <!-- v-if="FilesUploaded.UploadedFiles" -->

    <el-row v-if="evidencesList.Evidences">
      <el-col>
        <label style="font-weight: bold; margin-bottom: 105px">
          Evidencias
        </label>
        <!-- <label> {{evidencesList.Evidences}}</label> -->
        <a class="a-image" target="_blank" :href="evidencesList.Evidences">
          <img :src="evidencesList.Evidences" class="image" />
        </a>
        <h5>Clik para visualizar foto</h5>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          v-loading="commentsLoading"
          :columns="columns"
          :data="commentsList"
        />
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import { formatDate } from "@/utils";

export default {
  name: "InternalRequestDrawer",
  props: {
    data: {
      type: Object,
      default: () => ({
        requestsId: 0,
        comments: [],
        descripcionLaga: "",
        descripcionCorta: "",
        commentReasonToReopen: "",
        Reopen: "",
        evidences: []
      })
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    quillEditor
  },
  created() {
    //console.log("InternalRequestDrawer data: ", this.data);
    // console.log("InternalRequestDrawer drawer: ", this.drawer);
  },
  data() {
    return {
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      commentsLoading: false,
      evideLoading: false,
      uploadedFilesLoading: false,
      commentsList: [],
      evidencesList: [],
      FilesUploaded: [],
      columns: [
        {
          prop: "Comemnts",
          label: "Comentario",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "createByFullName",
          label: "Creado Por",
          minWidth: 150,
          fixed: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "UrlPhoto"
          }
        },
        {
          prop: "CreatedAt",
          label: "Fecha Creación",
          minWidth: 150,
          fixed: true,
          formatter: (row) => formatDate(row.CreatedAt, "DD/MM/yyyy")
        }
      ]
    };
  },
  methods: {
    async getComments() {
      this.commentsLoading = true;
      this.$http
        .get(`/api/InternalServiceRequest/getComments`, {
          params: { InternalRequestId: this.data.requestsId }
        })
        .then(({ data }) => {
          this.commentsList = data;
          if (data.length <= 0) {
            this.$message({
              type: "warning",
              message: "Esta solicitud aún no tiene comentarios"
            });
          }
        })
        .finally(() => {
          this.commentsLoading = false;
        });
    },
    async getEvidences() {
      this.evideLoading = true;
      this.$http
        .get(`/api/InternalServiceRequest/getEvidences`, {
          params: { InternalRequestId: this.data.requestsId }
        })
        .then(({ data }) => {
          this.evidencesList = data;
          if (data.Evidences === null) {
            this.$message({
              type: "warning",
              message: "Esta solicitud aún no tiene evidencias"
            });
          }
        })
        .finally(() => {
          this.evideLoading = false;
        });
    },

    async getFiles() {
      this.uploadedFilesLoading = true;
      this.$http
        .get(`/api/InternalServiceRequest/getInternalRequestFiles`, {
          params: { InternInternalRequestId: this.data.requestsId }
        })
        .then(({ data }) => {
          this.FilesUploaded = data;
          //console.log("Files Uploaded: " + this.FilesUploaded)
          if (data.UploadedFiles === null) {
            this.$message({
              type: "warning",
              message: "Esta solicitud aún no tiene Archivos Cargados"
            });
          }
        })
        .finally(() => {
          this.uploadedFilesLoading = false;
        });
    },

    handleClose() {
      this.commentsList = [];
      this.evidencesList = [];
      this.FilesUploaded = [];
      this.$emit("InternalRequestDrawerClose");
    }
  },
  watch: {
    drawer: function (newVal) {
      if (newVal == true) {
        this.getComments();
        this.getEvidences();
        this.getFiles();
      }
    }
  }
};
</script>

<style>
.a-image:hover {
  display: flex;
  box-shadow: 0px 0px 10px 0px;
}

.filesL {
  width: 40px;
  height: 50px;
  position: relative;
  right: 79px;
  margin-left: 2px;
}

.labelArc {
  position: relative;
  bottom: 65px;
  left: 25px;
}
</style>
